import {GET_STORE_DESIGN,API_URL,GET_STORE_DESIGN_URL}  from "./../../AppConfig"; 
 
export  const fetchStoreDesign = (storeId) => {
  
    return async dispatch => {  
      let storeDesignURL =API_URL +GET_STORE_DESIGN_URL+ '?storeId='+storeId; 
      await fetch(storeDesignURL, {method:'GET' 
      })
        .then(res => res.json())
        .then(storeDesign => { 
          // sessionStorage.setItem('storeDesign',JSON.stringify(storeDesign))
          dispatch({
          type:GET_STORE_DESIGN,
          payload:storeDesign
        })    
          }
        ); 
    }
  }
   


// WEBPACK FOOTER //
// ./src/redux/actions/designAction.js